import { render } from "./BanobagiMarketplacePanel.vue?vue&type=template&id=9a9da5a6&scoped=true"
import script from "./BanobagiMarketplacePanel.vue?vue&type=script&lang=js"
export * from "./BanobagiMarketplacePanel.vue?vue&type=script&lang=js"

import "./BanobagiMarketplacePanel.vue?vue&type=style&index=0&id=9a9da5a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a9da5a6"]])

export default __exports__